import { Injectable } from '@angular/core';
import { EditorComponent } from '@tinymce/tinymce-angular';

@Injectable({
  providedIn: 'root',
})
export class TextService {
  private readonly init: EditorComponent['init'] =
    {
      selector: 'textarea',
      plugins: 'lists link image wordcount save paste',
      paste_data_images: true,
      menubar: 'edit insert format',
      menu: {
        format: {
          title: 'Format',
          items: 'bold italic underline strikethrough superscript subscript | forecolor backcolor fontsize fontfamily | removeformat'
        }
      },
      statusbar: false,
      base_url: '/tinymce',
      object_resizing: false,
      image_dimensions: false,
      promotion: false,
      branding: false,
      suffix: '.min',
      file_picker_callback: (callback, value, meta) => {
        if (meta['filetype'] === 'image') {
          const input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';

          input.onchange = (event: Event) => {
            const file = (event.target as HTMLInputElement).files?.[0];

            if (file) {
              this.resizeAndCompressImage(file, 50, 850, 500, (finalDataUrl) => {
                callback(finalDataUrl, { alt: 'My alt text' });
              });
            }
          };

          input.click();
        }
      },
      setup: (editor) => {
        editor.on('paste', (event) => {
          const clipboardData = event.clipboardData || (event as any).originalEvent.clipboardData;
          const items = clipboardData.items;
    
          let imageFound = false;
    
          for (let value of items) {
            const item = value;
    
            if (item.type.indexOf('image') !== -1) {
              const file = item.getAsFile();
    
              if (file) {
                event.preventDefault(); 
                imageFound = true;
    
                this.resizeAndCompressImage(file, 50, 850, 500, (finalDataUrl) => {
                  editor.insertContent(`<img src="${finalDataUrl}" alt="My alt text" />`);
                });
              }
            }
          }
    
          if (!imageFound) {
            return;
          }
        });
      }
    };

  getEditorInit() {
    return this.init;
  }

  resizeAndCompressImage(file: File,maxFileSizeKB: number,maxWidth: number,maxHeight: number,
    callback: (compressedDataUrl: string) => void) {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;

      img.onload = () => {
        let targetWidth = img.width;
        let targetHeight = img.height;

        if (img.width > maxWidth || img.height > maxHeight) {
          if (img.width > img.height) {
            targetWidth = maxWidth;
            targetHeight = (img.height / img.width) * maxWidth;
          } else {
            targetHeight = maxHeight;
            targetWidth = (img.width / img.height) * maxHeight;
          }
        }

        const canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, targetWidth, targetHeight);

        let compressedDataUrl = canvas.toDataURL('image/jpeg', 1.0);
        const initialSizeKB = compressedDataUrl.length / 1024;
        if (initialSizeKB > maxFileSizeKB) {
          let quality = 0.9;
          while (compressedDataUrl.length/1024 > maxFileSizeKB && quality > 0.1) {
            quality -= 0.1;
            compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
          }
        }
        callback(compressedDataUrl);
      };
    };
    reader.readAsDataURL(file);
  }
}
